<template>
  <v-select
    :value="value"
    clearable
    :rules="rules"
    :label="label"
    :readonly="readonly"
    :error-messages="errorMessages"
    :items="days"
    menu-props="auto"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-select>
</template>

<script>
import { generateDays } from '@/modules/holidays/common/utils';
import { textLine } from '@/modules/_global/variables/rules';
export default {
  name: 'DaySelect',

  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    rules: {
      type: Array,
      default: () => textLine
    },
    year: {
      type: String,
      default: undefined
    },
    month: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      days: []
    };
  },

  watch: {
    month: 'checkDays',
    year: 'checkDays'
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.days = generateDays(this.year, this.month);
    },
    checkDays() {
      this.refreshData();
      if (this.value) {
        this.$emit('input', this.days.includes(this.value) ? this.value : null);
      }
    }
  }
};
</script>

<style scoped></style>
